import React from 'react'
import { connect } from 'react-redux'
import { changeLanguage } from '../../ducks/account'

class DefaultLanguageContainer extends React.Component {
  componentDidMount() {
    if (this.props.currentLanguage === null) {
      this.props.changeLanguage('en')
    }
  }

  render() {
    return React.cloneElement(this.props.children, {
      ...this.props
    })
  }
}

export default connect(
  state => ({
    currentLanguage: state.account.get('currentLanguage')
  }),
  {
    changeLanguage
  }
)(DefaultLanguageContainer)



// WEBPACK FOOTER //
// ./src/components/smart/DefaultLanguageContainer.js